import { Fragment } from 'react'

import s from './result.module.scss'

const result = [
  {
    name: 'Axie: Infinity Omelette',
    thumbnail_url:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1698572275-thumbnail-nhatlongnguyen.png',
    place: 1,
    description:
      'Axie: Infinity Omelette is a game that revolves around the core gameplay of bomb placement, coupled with a familiar progression system from the roguelite game genre. The game\'s plot follows Dr. Robot as he creates Chimeras to steal Axies\' eggs for research purposes. However, during the research process, three eggs hatch, each imbued with the ability to produce explosive egg bombs and special skills. This leads the Axies faction to harness this newfound power, launching attacks into the Dungeon and Laboratory of the scientist. Thus ensues an endless and inexhaustible battle between the two factions.',
    candidate: '5tin Eggs',
    slug: 'infinity-omelette',
    genres: ['Strategy', 'RPG', 'Action RPG'],
  },
  {
    name: 'Axie: The Last Fox',
    thumbnail_url:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1698302828-thumbnail.jpg',
    place: 2,
    description:
      'An ARPG where you must use your skills and strategy to save your homeland!',
    candidate: 'Kazuma',
    slug: 'axie-the-last-fox',
    genres: ['Action RPG', 'Survival'],
  },
  {
    slug: 'axie-party',
    name: 'AxieParty',
    description:
      'Game inspired by Party Games where you will have to fight against others to improve your axie and thus rise to victory, use your upgrades and skills to take the lead and become the king of Lunacia.',
    thumbnail_url:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1698587549-axiepartythumnail-juanlaurino.png',
    place: 3,
    candidate: 'Bloom Umbrella',
    genres: ['Battle Royale', 'Hypercasual', 'Sports', 'Racing'],
  },
  {
    slug: 'axie-auto-chess',
    name: 'Axie AutoChess',
    description:
      'Put your team-building skills to the test in Axie-AutoChess, the ultimate multiplayer PvP auto battler',
    thumbnail_url:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1698554886-chessbanner-564-ĐàoThanhTú.png',
    place: 4,
    candidate: 'Rubik Studio',
    genres: ['Turn-based', 'Strategy', 'Auto battler', 'Merge'],
  },
  {
    slug: 'turd-tycoon',
    name: 'Turd Tycoon',
    description: 'Build your Axie empire and become a poop millionaire',
    thumbnail_url:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1698561068-Thumbnail-JohannesHigatzberger.png',
    place: 5,
    candidate: 'Groovy Frogs',
    genres: ['Simulation'],
  },
]

const picks = [
  {
    slug: 'axie-world',
    name: 'Axie World: Atia\'s Legacy',
    description:
      'Discover the vast world of Lunacia, a place filled with magic and secrets. Gather your group and face powerful creatures, level up your Axie, and obtain the best equipment to defend the land from the chimera!',
    thumbnail_url:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1698588920-game_thumbnail-eduardoyepes.png',
    candidate: 'TactiGames',
    genres: ['RPG', 'MMORPG'],
  },
  {
    slug: 'axie-darkness-arise',
    name: 'Axie Darkness Arise',
    description:
      'Save the forest from the hordes of enemies, Lunacia needs you!',
    thumbnail_url:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1698569800-imagen_2023-10-28_165209398-juanneyra.png',
    candidate: 'Shadow Wizard',
    genres: ['Strategy', 'Action RPG'],
  },
  {
    slug: 'axie-bump-hero',
    name: 'Axie Bump Hero',
    description: 'Enter the arena to fight to bring victory to your axies',
    thumbnail_url:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1698555893-Dựánmới-caonguyễn.png',
    candidate: 'caont',
    genres: ['Strategy', 'Fighting'],
  },
]

export const Result = () => {
  return (
    <div className={s.container}>
      <div className={s.veroki} />
      <img src="/assets/axie-game-jam/mavis-bird.png" className={s.topImage} />
      <h2 className={s.title}>Axie Game Jam 2023 Winners</h2>
      <p className={s.description}>
        All jammers have created truly amazing games in 2-week development
        period using Axie Infinity. For many of them, it’s their first game
        ever!
      </p>
      <div className={s.result}>
        {result.map(game => (
          <div className={s.award} data-place={game.place} key={game.slug}>
            <div className={s.medal} />
            <div className={s.thumbnail}>
              <img src={game.thumbnail_url} />
            </div>
            <div className={s.detail}>
              <h4 className={s.gameName}>{game.name}</h4>
              <div className={s.genres}>
                {game.genres.map(genre => (
                  <span key={genre}>{genre}</span>
                ))}
              </div>
              <div className={s.author}>
                by <strong>{game.candidate}</strong>
              </div>
              {game.place === 1 && (
                <Fragment>
                  <p className={s.gameDesc}>{game.description}</p>
                  <a className={s.gameLink} href={`/games/${game.slug}`}>
                    View details
                  </a>
                </Fragment>
              )}
            </div>
            {game.place !== 1 && (
              <div className={s.gameOverview}>
                <p className={s.gameDesc}>{game.description}</p>
                <a className={s.gameLink} href={`/games/${game.slug}`}>
                  View details
                </a>
              </div>
            )}
          </div>
        ))}
      </div>

      <img src="/assets/axie-game-jam/editor-pick.png" className={s.topImage} />
      <h2 className={s.subtitle}>Editor Picks</h2>
      <div className={s.editorpicks}>
        {picks.map(game => (
          <div className={s.pick} key={game.slug}>
            <div className={s.thumbnail}>
              <img src={game.thumbnail_url} />
            </div>
            <div className={s.name}>{game.name}</div>
            <div className={s.genres}>
              {game.genres.map(genre => (
                <span key={genre}>{genre}</span>
              ))}
            </div>
            <div className={s.author}>
              by <strong>{game.candidate}</strong>
            </div>
            <p className={s.gameDesc}>{game.description}</p>
            <a className={s.gameLink} href={`/games/${game.slug}`}>
              View details
            </a>
          </div>
        ))}
        <div className={s.puffy} />
      </div>

      <div className={s.foot}>
        <a href="/axie-game-jam/2023/submissions" className={s.explore}>
          View all game submissions
        </a>
      </div>
    </div>
  )
}
